/**
 * created by wang lei
 日期页面
 *
 */
import React, {Component} from 'react';
import date from './date.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class DateTool extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <span style={{cursor:"pointer"}} onClick={()=>{
                this.props.editor.execCommand( 'date');
            }}>
                <img className={"editor-data-tool-btn"} src={date}/>
                <style>{`
                    .editor-data-tool-btn{
                        border: 1px solid #f2f6fc
                    }
                    .editor-data-tool-btn:hover{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                    }
                    .editor-data-tool-btn:active{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                    }
                `}</style>
            </span>
        )
    }

}